if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      // console.log(MutationList);
      for (let item of MutationList) {
        if (item.target.classList.contains("product-quick-view-content")) {
          document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`));
        }
        if (item.target.classList.contains("quantity__label")) {
          BSS_B2B.observer.productSubject.notifyObserver(
            "ProductMutate",
            "ProductPriceMutate"
          );
        }
        if (
          item.target.classList.contains("totals__total-value") ||
          item.target.classList.contains("drawer__inner")
        ) {
          handleCartDrawerFooterMutation();
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);
  document.addEventListener("DOMContentLoaded", (e) => {
    const isPDP = window.location.pathname.includes("/products/");
    if (isPDP) {
      document.querySelector("product-add-to-cart-sticky")?.remove();
    }
  });
}

async function handleCartDrawerFooterMutation() {
  if (BSS_B2B) {
    const res = await BSS_B2B.storage.productStorage.load();
    if (res) {
      if (
        res.notExistProductIds?.length ||
        res.productIds?.length ||
        res.variantIds?.size
      ) {
        BSS_B2B.observer.productSubject.notifyObserver(
          "LazyProduct",
          "LoadedLazyProduct",
          {
            ...res,
          }
        );
      }
    }
  }
}

  setTimeout(() => {

    bssB2BArrayState.GB =  {
        "provinces": [
            { "id": "England", "label": "England", "value": "ENG" },
            {
                "id": "Northern Ireland",
                "label": "Northern Ireland",
                "value": "NIR"
            },
            { "id": "Scotland", "label": "Scotland", "value": "SCT" },
            { "id": "Wales", "label": "Wales", "value": "WLS" }
        ],
        "labels": { "zip": "Postcode", "province": "Region" }
    }
  }, 3000);
